import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=4309d154&scoped=true"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomer.vue?vue&type=style&index=0&id=4309d154&prod&scoped=true&lang=css"
import style1 from "./UpdateCustomer.vue?vue&type=style&index=1&id=4309d154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309d154",
  null
  
)

export default component.exports